import axios from 'axios'

import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    activities: [],
    activitiesSubProducts: [],
    activitiesLoaded: false,
  }),
  mutations: {
    SET_ACTIVITIES(state, activities) {
      state.activities = activities
      state.activitiesLoaded = true
    },
    SET_ACTIVITIES_SUBPRODUCT(state, activities) {
      state.activitiesSubProducts = activities
      state.activitiesLoaded = true
    },
  },
  actions: {
    async fetchActivities({ commit, state }) {
      if (!state.activitiesLoaded) {
        const res = await axios.get('sfdaeg/sections')
        const data = decryptData(res.data.payload).data.sections
        const formattedProduct = data.map(item => ({
          value: item.id,
          text: `${item.name.ar} - ${item.name.en}`,
        }))
        const formattedSubProduct = data.map(item => ({
          label: `${item.name.ar} - ${item.name.en}`,
          options: item.product_categories.map(product => ({
            value: product.id,
            text: product.name,
          })),
        }))

        commit('SET_ACTIVITIES', [...formattedProduct])
        commit('SET_ACTIVITIES_SUBPRODUCT', [...formattedSubProduct])
      }
    },
  },
  getters: {
    activities: state => state.activities,
    activitiesSubProducts: state => state.activitiesSubProducts,
    activitiesLoaded: state => state.activitiesLoaded,
  },
}
